export const getPerformanceUrl = (locationId: string, agentId: string) => `
/business/locations/${locationId}/agents/${agentId}/performance`;

export const getRecommendationsUrl = (locationId: string, agentId: string) => `
/business/locations/${locationId}/agents/${agentId}/recommendations`;

export const getRecommendationsOverviewUrl = (locationId: string, agentId: string) => `
/business/locations/${locationId}/agents/${agentId}/recommendations/overview`;

export const getAcceptRecommendationUrl = (locationId: string, agentId: string, id: string) => `
/business/locations/${locationId}/agents/${agentId}/recommendations/${id}/accept`;

export const getRejectRecommendationsUrl = (locationId: string, agentId: string, id: string) => `
/business/locations/${locationId}/agents/${agentId}/recommendations/${id}/reject`;
